import * as Tone from 'tone';
import AudioEffect from '../effects/audio/AudioEffect';
import Chain from './Chain';
class AudioChain extends Chain {
    constructor() {
        super();
        this.inputNode = new Tone.Gain(0, "decibels");
        this.outputNode = new Tone.Gain(0, "decibels");
        this.reconnect();
    }
    input() { return this.inputNode; }
    output() { return this.outputNode; }
    insert(device, position) {
        if (position === undefined) {
            position = this.devices.length;
        }
        this.devices[position] = device;
        this.reconnect();
    }
    reconnect() {
        // disconnect chain
        this.input().disconnect();
        for (const device of this.devices) {
            device.output().disconnect();
        }
        if (this.devices.length === 0) {
            this.input().connect(this.output());
            return;
        }
        const [firstDevice] = this.devices;
        this.input().connect(firstDevice.input());
        for (let i = 0; i < this.devices.length; i++) {
            const device = this.devices[i];
            const nextDevice = this.devices[i + 1];
            if (!(device instanceof AudioEffect)) {
                throw 'An AudioChain can only contain AudioEffects';
            }
            if (nextDevice !== undefined) {
                if (!(nextDevice instanceof AudioEffect)) {
                    throw 'An AudioChain can only contain AudioEffects';
                }
                device.output().connect(nextDevice.input());
            }
            else {
                device.output().connect(this.output());
            }
        }
    }
}
export default AudioChain;
//# sourceMappingURL=AudioChain.js.map